import { CHeader, CContainer } from '@coreui/react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import Icon from 'components/icon/Icon';
import { selectShow, toggleShow } from 'features/menu';
import { AppHeaderDropdown } from './AppHeaderDropdown';
import './AppHeader.scss';
import { AppBreadcrumb } from 'components/breadcrumb';

export const AppHeader = () => {
    const dispatch = useAppDispatch();
    const sidebarShow = useAppSelector((state) => selectShow(state));

    return (
        <>
            <CHeader position="sticky" className="main-header mb-2">
                <CContainer fluid className="d-flex align-items-center">
                    <div 
                        className="header-toggle-btn"
                        onClick={() => dispatch(toggleShow(!sidebarShow))}
                        role="button"
                        tabIndex={0}
                    >
                        <Icon icono="mdiMenu" size={1.2} className="text-white" />
                    </div>

                    <div className="header-title">
                        LÍDERES EN ACCIÓN
                    </div>

                    <div className="header-actions">
                        <AppHeaderDropdown />
                    </div>
                </CContainer>
            </CHeader>
            <CHeader className="breadcrumb-header mb-3">
                    <AppBreadcrumb />
            </CHeader>
        </>
    );
}